import './components/lazy';
import './components/ellipsis';
import './components/splide';
import './components/popup';
import './components/totop';
import './components/dropdown';
import './components/browse-file';
import './components/header';
import './fe';
import './be';